module.exports = __webpack_public_path__ + "static/media/femec-logotip-color.9e40eae3.png";